import { render, staticRenderFns } from "./licenceCllect.vue?vue&type=template&id=c7800f16&scoped=true&"
import script from "./licenceCllect.vue?vue&type=script&lang=js&"
export * from "./licenceCllect.vue?vue&type=script&lang=js&"
import style0 from "./licenceCllect.vue?vue&type=style&index=0&id=c7800f16&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7800f16",
  null
  
)

export default component.exports